/* eslint-disable prefer-destructuring */
import qs from 'qs';

export const GET_PERSONAL_POINTS_ACTIVITY_PENDING = 'GET_PERSONAL_POINTS_ACTIVITY_PENDING';
export const GET_PERSONAL_POINTS_ACTIVITY_FULFILLED = 'GET_PERSONAL_POINTS_ACTIVITY_FULFILLED';
export const GET_PERSONAL_POINTS_ACTIVITY_REJECTED = 'GET_PERSONAL_POINTS_ACTIVITY_REJECTED';
export const GET_PERSONAL_POINTS_ACTIVITY = 'GET_PERSONAL_POINTS_ACTIVITY';

export const GET_POINTS_STATEMENT_OUTLETS_PENDING = 'GET_POINTS_STATEMENT_OUTLETS_PENDING';
export const GET_POINTS_STATEMENT_OUTLETS_FULFILLED = 'GET_POINTS_STATEMENT_OUTLETS_FULFILLED';
export const GET_POINTS_STATEMENT_OUTLETS_REJECTED = 'GET_POINTS_STATEMENT_OUTLETS_REJECTED';

export default function pointsStatementReducer(state = {
  personalList: [],
  personalListPaging: {
    number: 1,
    size: 10
  },
  personalPostcodePlanList: [],
  personalPostcodePlanListPaging: {
    number: 1,
    size: 10
  },
  staffList: [],
  staffListPaging: {
    number: 1,
    size: 10
  },
  fetching: false,
  fetched: false,
  outletsFetched: false,
  outletsFetching: false,
  outlets: [],
  errors: {}
}, action) {
  switch (action.type) {
    case GET_PERSONAL_POINTS_ACTIVITY_FULFILLED:
    case 'GET_PERSONAL_POINTS_STATEMENT_FULFILLED': {
      const lastPage = action.payLoad.links.last;
      let page = state.personalListPaging;
      if (lastPage) {
        page = qs.parse(lastPage.split('?')[1]).page;
      }

      return {
        ...state,
        fetching: false,
        fetched: true,
        personalList: action.payLoad.data,
        personalListPaging: page
      };
    }
    case GET_PERSONAL_POINTS_ACTIVITY_REJECTED:
    case GET_POINTS_STATEMENT_OUTLETS_REJECTED:
    case 'GET_PERSONAL_POINTS_STATEMENT_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    case GET_POINTS_STATEMENT_OUTLETS_PENDING: {
      return {
        ...state,
        outletsFetched: false,
        outletsFetching: true,
      };
    }
    case GET_POINTS_STATEMENT_OUTLETS_FULFILLED: {
      return {
        ...state,
        outletsFetched: true,
        outletsFetching: false,
        outlets: action.payLoad.data,
      };
    }
    default: {
      return {...state};
    }
  }
}
